var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"editor"},[_c('editor',{attrs:{"value":_vm.value,"init":_vm.init},on:{"input":_vm.onInput}}),(!_vm.value)?_c('div',{staticClass:"pla"},[_vm._v(" 请输入详情内容，可自由编辑文字版式，可添加图片和视频，图片支持jpg/png/gif格式，单张图片不超过1M，上传本地视频时仅支持mp4格式，大小不超过50M ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }